import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { API } from '../../../constants/api';

import {
  StyledReportListItem,
  StyleReportBtnWrapper,
  StyledSpan,
  StyledIconShare,
  StyledIconNav,
  StyledFormatTxt
} from './style';

import { Share, Dots, Close } from '../../../../assets/images/index';

class ShareReportItem extends Component {
  constructor() {
    super();

    this.state = {
      active: window.innerWidth > 721
    };
  }

  render() {
    const { data, onClickIconShare } = this.props;
    const { active } = this.state;

    const { name, pdf, xls } = data;
    const pdfUrl = pdf ? `${API}files${pdf}` : '';
    const pdfName = pdfUrl ? pdfUrl.substring(pdfUrl.lastIndexOf('/') + 1) : '';
    const xlsUrl = xls ? `${API}files${xls}` : '';
    const xlsName = xlsUrl ? xlsUrl.substring(xlsUrl.lastIndexOf('/') + 1) : '';

    return (
      <StyledReportListItem>
        <StyledSpan>{name}</StyledSpan>{' '}
        {active && (
          <StyleReportBtnWrapper active={active}>
            {pdf && (
              <StyledFormatTxt href={pdfUrl} target="_blank" format="PDF" />
            )}
            {xls && (
              <StyledFormatTxt href={xlsUrl} target="_blank" format="XLS" />
            )}
            <StyledIconShare
              svg={Share}
              size="smm"
              hover
              onClick={() => {
                onClickIconShare(pdfUrl, pdfName, xlsUrl, xlsName);
              }}
            />
            <StyledIconNav
              onClick={() => {
                this.setState({
                  active: false
                });
              }}
              svg={Close}
              size="s"
              hover
              color="light"
            />
          </StyleReportBtnWrapper>
        )}
        <StyledIconNav
          onClick={() => {
            this.setState({
              active: true
            });
          }}
          svg={Dots}
          size="sm"
          hover
        />
      </StyledReportListItem>
    );
  }
}

ShareReportItem.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    pdf: PropTypes.string,
    xls: PropTypes.string
  }).isRequired,
  onClickIconShare: PropTypes.func
};

export default ShareReportItem;
